
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 3h12a3 3 0 013 3v12a3 3 0 01-3 3H6a3 3 0 01-3-3V6a3 3 0 013-3zm5.578 9.42c0-1.184-.29-2.092-.871-2.724-.582-.631-1.42-.947-2.518-.947-1.097 0-1.939.313-2.526.94-.588.627-.882 1.534-.882 2.722s.293 2.1.88 2.735c.585.634 1.425.952 2.519.952 1.093 0 1.933-.318 2.52-.952.585-.635.878-1.543.878-2.725zm-5.21 0c0-.797.153-1.398.46-1.803.305-.406.76-.608 1.361-.608 1.202 0 1.802.804 1.802 2.412 0 1.605-.604 2.407-1.811 2.407-.603 0-1.055-.202-1.358-.605-.302-.404-.454-1.005-.454-1.802zM18.8 16l-2.51-3.98 2.49-3.159H17.1l-1.933 2.427-.596.84V8.86h-1.513V16h1.513v-2.549l.64-.459L17.08 16H18.8z","fill-rule":"evenodd"}})])
          )
        }
      }
    